const constantes = {
  roles: {
    ADMIN: 'ROLE_SUPER_ADMIN',
    USUARIO: 'ROLE_USER'
  },
  gruposRutas: {
    PUBLICAS: 'PUBLICAS',
    USUARIO: 'USUARIO',
    ADMIN: 'ADMIN'
  },
  usuarios: {
    tipos: {
      AFICIONADO: 'AFICIONADO',
      PROFESIONAL: 'PROFESIONAL',
      ESTUDIANTE: 'ESTUDIANTE'
    }
  },
  ofertas: {
    tiposPackFotos: {
      DINAMICO: 'DINÁMICO',
      MIN_MAX_FIJO: 'MIN MAX FIJO',
      MIN_MAX_POR_UNIDAD: 'MIN MAX POR UNIDAD',
      FIJO: 'FIJO'
    }
  },
  tiposSubida: {
    PACK_FOTO: 'PACK FOTO',
    OFERTA: 'OFERTA'
  },
  pedidos: {
    resultados: {
      SUCCESS: 'success',
      FAILURE: 'failure',
      PENDING: 'pending'
    },
    estados: {
      CARGANDO: 'CARGANDO',
      PENDIENTE_PAGO: 'PENDIENTE_PAGO',
      CREADO: 'CREADO',
      PROCESANDO: 'PROCESANDO',
      ENVIO_PENDIENTE: 'ENVIO_PENDIENTE',
      PARA_RETIRO: 'PARA_RETIRO',
      CERRADO: 'CERRADO',
      CANCELADO: 'CANCELADO'
    },
    tipos: {
      TRADICIONAL: {
        texto: 'Tradicional',
        descripcion: 'Sencillo. Elegí un tamaño, tus fotos y subí el pedido. Luego pasá a abonarlo y retirarlo por el local.',
        textoEntidad: 'TRADICIONAL'
      },
      COMPRA_ONLINE: {
        texto: 'Compra ONLINE',
        descripcion: 'Rápido y cómodo. Elegí tamaño, subí tus fotos y por ultimo seleccioná medio de pago y datos de envío (opcional). Recibilas comodamente en tu casa o retiralas por el local ya abonadas.',
        textoEntidad: 'COMPRA_ONLINE'
      },
      COMPRA_ONLINE_CON_MERCADO_ENVIOS: {
        texto: 'Compra ONLINE + Envío Resto del País',
        descripción: '',
        textoEntidad: 'COMPRA_ONLINE_CON_MERCADO_ENVIOS'
      },
      COMPRA_ONLINE_CON_ENVIO: {
        texto: 'Compra ONLINE + Envío Paraná',
        descripción: '',
        textoEntidad: 'COMPRA_ONLINE_CON_ENVIO'
      }
    },
    tiposEntrega: {
      RETIRO_LOCAL: {
        texto: 'Retiro en Local',
        descripcion: 'Paraná, Entre Ríos. Calle Uruguay N° 32.'
      },
      ENVIO_DOMICILIO: {
        texto: 'Envío Paraná',
        descripcion: 'Envíos gratis en promociones vigentes.'
      },
      ENVIO_RESTO_DEL_PAIS: {
        texto: 'Envío Resto del País',
        descripcion: 'A través de Mercado Envíos.'
      }
    },
    turnosEntrega: [
      'Indistinto',
      'Tarde',
      'Mañana'
    ]
  }
}
export default constantes
